<!-- //
普通下拉
@author xuyd
@date 2024-5-2
//-->
<template>
  <el-select
      style="width: 100%;"
      filterable
      :clearable="clearable"
      :size="options.size"
      :placeholder="placeholder"
      :popper-class="popperClass"
      :multiple="multiple"
      v-model="inputData"
      @change="handleChange">
    <el-option
        v-for="(item, index) in dataSource"
        :key="index"
        :value="item[options.value]"
        :label="item[options.label]"/>
  </el-select>
</template>
<script>

export default {
  name: 'CompSelectorKeyValue',
  data() {
    return {
      dataSource: [...this.datasourceList],
      inputData: this.value,
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          size: 'small',
          value: 'dictValue',
          label: 'dictLabel'
        }
      }
    },
    value: [String, Number],
    datasourceList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {// 多选
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    popperClass: String,
  },
  watch: {
    value: {
      handler(val) {
        this.inputData = val;
      },
      immediate: true
    },
    datasourceList: {
      handler(val) {
        this.dataSource = [...val]
      },
      immediate: true
    },
  },
  methods: {
    handleChange(val) {
      console.log("-------handleChange-------", val);
      let item = this.dataSource.find(item => item[this.options.value] === val);
      this.$emit('change', val, item)
    },
  }
}
</script>

<style lang="less" scoped>
</style>
